import * as React from 'react';

import styles from './NoImage.css';
import { NoImageIcon } from '../../../common/icons';

export const NoImage = (props: { text?: string }) => {
  const { text = 'Нет фото' } = props;

  return (
    <div className={styles['no_image']}>
      <div className={styles['no_image-icon']}>
        <NoImageIcon />
      </div>
      <span className={styles['no_image-text']}>{text}</span>
    </div>
  );
};
